import { TApplicationState } from '../../types/redux';

export function getNewbuildingDisplayName(state: TApplicationState) {
  const {
    newbuilding: { displayName },
  } = state;

  if (displayName) {
    return displayName;
  }

  return '';
}
